import { Injectable } from '@angular/core';
import { ScopeService } from './scope.service';

/**
 * Regroups some function used in different spreadsheet (handsontable context)
 */
@Injectable()
export class SpreadsheetMenuService {

  constructor(
    private scopeService: ScopeService,
  ) {}


  public userHasPermission(
    permission: string,
  ): () => boolean {
    return () => {
      let hasPermission: boolean = false;
      if (permission) {
        this.scopeService.user$.subscribe((user) => {
          if (user) {
            hasPermission = user[permission];
          }
      });
    }
    return hasPermission;
    };
  }

}
